import React, { useMemo } from 'react';
import { DialogContent } from '@material-ui/core';

import { RULES } from 'src/lib/validation';
import { useValidatedForm } from 'src/lib/hooks';
import { useStyles } from './useStyles';
import { useViewState } from './useViewState';
import { CustomDialog } from 'src/components/CustomDialog';
import CustomInput from 'src/components/CustomInput';
import { ErrorMessage } from 'src/components/ErrorMessage';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { useHandlers } from './useHandlers';

export const BrandVoicePopup = ({ open, onClose, brandVoice }) => {
  const styles = useStyles();

  const { isSavingBrandVoice } = useViewState();

  const initialFields = useMemo(() => ({ name: brandVoice?.name }), [brandVoice]);
  const {
    fields,
    errors,
    validate,
    update: updateForm,
  } = useValidatedForm({
    initialFields,
    rules: {
      name: {
        [RULES.required]: { message: 'Brand voice name is required' },
        [RULES.max_length]: { value: 50, message: 'The maximum length is 50 characters' },
      },
    },
    enableReinitialize: true,
  });

  const { handleSubmit } = useHandlers({
    onClose,
    validate,
    id: brandVoice?.id,
    name: fields.name,
  });

  return (
    <CustomDialog
      className={styles.root}
      onClose={onClose}
      data-testid="brandVoicePopup"
      title={brandVoice?.name ? 'Change brand voice name' : 'Create new brand voice'}
      onSubmit={handleSubmit}
      onCancel={onClose}
      submitLabel={brandVoice?.name ? 'Save' : 'Create'}
      cancelLabel="Cancel"
      disabled={isSavingBrandVoice}
      loading={isSavingBrandVoice}
      open={open}
      fullWidth
      classes={{
        root: styles.root,
        dialogTitle: styles.dialogTitle,
        title: styles.title,
        dialogActions: styles.dialogActions,
        buttonCancel: styles.buttonCancel,
        buttonSubmit: styles.buttonSubmit,
      }}
    >
      <DialogContent className={styles.dialogContent}>
        <CustomTypography
          className={styles.inputLabel}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          Brand voice name
        </CustomTypography>
        <CustomInput
          dataTestId="brandVoicePopupInput"
          className={styles.field}
          value={fields.name}
          onChange={(e) => updateForm('name', e.target.value)}
          error={errors.name}
          placeholder="Brand voice name"
          disabled={isSavingBrandVoice}
          autoFocus
        />
        <ErrorMessage error={errors.name} />
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph12}
        >
          <span>*</span>{' '}
          <span>
            This brand voice will be available in every workspace.
            <br />
            Only admins can edit this brand voice.
          </span>
        </CustomTypography>
      </DialogContent>
    </CustomDialog>
  );
};
